declare global {
  const _VERSION: string;
}

export default _VERSION;
